import React from 'react'

import { useMessage } from '../../hooks/message'
import { usePostRequest } from '../../hooks/request'
import { BUILDING_LIST } from '../../urls'
import BuildingForm from './BuildingForm'

export default function BuildingCreate({ onCancel, categoryList, expenseReport, brandList }) {
    const products = usePostRequest({ url: BUILDING_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success, error } = await products.request({ data })
        if (success) {
            expenseReport.request()
            onCancel()
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Қўшиш</b>
            </h1>
            <BuildingForm loading={products.loading} categoryList={categoryList} brandList={brandList}
                onCancel={onCancel}
                onSubmit={onSubmit} />
        </div>
    )
}
